"use strict";

function ut$(a) {
  return ddSdk_1.ddSdk.invokeAPI(apiName, a);
}

var _a;

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ut$ = void 0;

var ddSdk_1 = require("../../../lib/ddSdk"),
    apiName = "biz.util.ut",
    utParamsObj2Str = function utParamsObj2Str(a) {
  var e = Object.assign({}, a),
      t = e.value,
      d = [];

  if (t && "object" == typeof t) {
    for (var r in t) {
      void 0 !== t[r] && d.push(r + "=" + t[r]);
    }

    t = d.join(",");
  }

  return e.value = t || "", e;
};

ddSdk_1.ddSdk.setAPI(apiName, (_a = {}, _a[ddSdk_1.ENV_ENUM.pc] = {
  vs: "3.5.0",
  paramsDeal: utParamsObj2Str
}, _a[ddSdk_1.ENV_ENUM.ios] = {
  vs: "2.4.0",
  paramsDeal: function paramsDeal(a) {
    var e = Object.assign({}, a),
        t = e.value;
    return t && "object" == typeof t && (t = JSON.stringify(t)), e.value = t, e;
  }
}, _a[ddSdk_1.ENV_ENUM.android] = {
  vs: "2.4.0",
  paramsDeal: utParamsObj2Str
}, _a)), exports.ut$ = ut$, exports.default = ut$;